module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-2-3c1936c82ce2a670388745fa75fa6461.jpg";